import { RoutePath } from 'enums/routePath';

const ROOT = '/whitespace-matrix';

const WHITESPACE_AGREEMENT_ADDITION_MAP = `${ROOT}/agreement-addition-mapping`;
const WHITESPACE_AGREEMENT_TYPE = `${ROOT}/agreement-types`;
const WHITESPACE_PRODUCT_ADDITIONS = `${ROOT}/product-additions`;

const paths = {
  [RoutePath.WHITESPACE]: ROOT,
  [RoutePath.WHITESPACE_AGREEMENT_ADDITION_MAP]:
    WHITESPACE_AGREEMENT_ADDITION_MAP,
  [RoutePath.WHITESPACE_AGREEMENT_TYPE]: WHITESPACE_AGREEMENT_TYPE,
  [RoutePath.WHITESPACE_PRODUCT_ADDITIONS]: WHITESPACE_PRODUCT_ADDITIONS,
};

export const pathArray = Object.values(paths);

export default paths;
